import { useParams } from "react-router-dom";
import Breadcrumb from "../../components/Breadcrumb";
import Card from "../../components/Card";

const AgentUserDetails = () => {
  const { companyId } = useParams();
  const user = JSON.parse(localStorage.getItem("userInfo"));

  return (
    <div id="agent-user-details">
      <Breadcrumb pageName="User Details" />
      <div className="pb-6">
        <Card>
          <div className="p-6">
            <div className="space-y-4">
              <div className="flex justify-between py-3 border-b border-gray-200">
                <span className="text-gray-600">Name</span>
                <span className="text-secondary font-medium">
                  {user?.firstName} {user?.lastName}
                </span>
              </div>
              <div className="flex justify-between py-3 border-b border-gray-200">
                <span className="text-gray-600">LIC</span>
                <span className="text-secondary font-medium">
                  {user?.licenseNo || "-"}
                </span>
              </div>
              <div className="flex justify-between py-3 border-b border-gray-200">
                <span className="text-gray-600">Email</span>
                <span className="text-secondary font-medium">
                  {user?.email || "-"}
                </span>
              </div>
              <div className="flex justify-between py-3 border-b border-gray-200">
                <span className="text-gray-600">Phone</span>
                <span className="text-secondary font-medium">
                  {user?.phone || "-"}
                </span>
              </div>
            </div>
          </div>
        </Card>
      </div>
    </div>
  );
};

export default AgentUserDetails;
